import HealthScoreHeader from ".";

export default function HealthScoreHeaderExamples() {
  return <HealthScoreHeader />;
}
